var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcheckpayAsset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 290.469,
    height: 135.491,
    viewBox: "0 0 290.469 135.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        font-size: 48px;\n        font-family: ArialMT, Arial;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: #000;\n        stroke-width: 2px;\n      }\n\n      .cls-5 {\n        stroke-linecap: round;\n      }\n\n      .cls-6 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_payment_1471517",
    transform: "translate(-23 17.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(23 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M264.456,0H26.013c-.993,0-1.988,0-2.979,0-.838,0-1.674.011-2.51.028a49.754,49.754,0,0,0-5.463.35A23.532,23.532,0,0,0,9.869,1.629,18.314,18.314,0,0,0,5.446,3.97,13.775,13.775,0,0,0,2.234,7.192a11.071,11.071,0,0,0-1.71,3.785,19.456,19.456,0,0,0-.483,3.979C.019,15.564.01,16.174,0,16.783,0,17.506,0,18.23,0,18.955v97.583c0,.725,0,1.447,0,2.172.005.609.015,1.218.038,1.827a19.448,19.448,0,0,0,.483,3.977,11.068,11.068,0,0,0,1.71,3.785,13.748,13.748,0,0,0,3.212,3.222,18.208,18.208,0,0,0,4.422,2.34,23.435,23.435,0,0,0,5.192,1.249,50.139,50.139,0,0,0,5.463.35q1.254.021,2.51.025c.991.006,1.986.006,2.979.006H264.456c.991,0,1.986,0,2.977-.006q1.254,0,2.512-.025a50.274,50.274,0,0,0,5.463-.35,23.453,23.453,0,0,0,5.19-1.249,18.225,18.225,0,0,0,4.422-2.34,13.83,13.83,0,0,0,3.212-3.222,11,11,0,0,0,1.71-3.785,19.441,19.441,0,0,0,.48-3.977c.023-.609.034-1.218.038-1.827.008-.725.008-1.447.008-2.172V18.955c0-.725,0-1.448-.008-2.172,0-.609-.015-1.218-.038-1.827a19.449,19.449,0,0,0-.48-3.979,11.005,11.005,0,0,0-1.71-3.785,13.857,13.857,0,0,0-3.212-3.222,18.332,18.332,0,0,0-4.422-2.34,23.551,23.551,0,0,0-5.19-1.247,49.887,49.887,0,0,0-5.463-.35c-.84-.017-1.676-.023-2.512-.028-.991,0-1.986,0-2.977,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "cls-1",
    d: "M264.914,3.532l2.969,0c.8,0,1.608.01,2.417.026a43.312,43.312,0,0,1,4.586.28,15.965,15.965,0,0,1,3.525.829,11.979,11.979,0,0,1,2.878,1.5,8.99,8.99,0,0,1,2.1,2.084,7.227,7.227,0,0,1,1.145,2.535,16.35,16.35,0,0,1,.389,3.3c.022.575.032,1.15.036,1.739.008.712.007,1.424.007,2.137v97.583c0,.713,0,1.424-.008,2.151,0,.575-.014,1.15-.036,1.726a16.325,16.325,0,0,1-.392,3.31,7.207,7.207,0,0,1-1.144,2.525,8.941,8.941,0,0,1-2.1,2.078,11.918,11.918,0,0,1-2.892,1.511,15.828,15.828,0,0,1-3.5.825,44.062,44.062,0,0,1-4.571.281c-.812.013-1.621.021-2.449.024-.987.005-1.978.005-2.965.005H23.547c-.976,0-1.954,0-2.947-.005-.81,0-1.618-.01-2.4-.023a44.134,44.134,0,0,1-4.588-.28,15.88,15.88,0,0,1-3.527-.831A11.871,11.871,0,0,1,7.2,127.342a8.88,8.88,0,0,1-2.093-2.075,7.287,7.287,0,0,1-1.148-2.538,16.264,16.264,0,0,1-.391-3.3c-.022-.579-.031-1.157-.036-1.732l0-1.7V17.522l0-1.694c.005-.579.014-1.157.036-1.735a16.278,16.278,0,0,1,.393-3.307A7.278,7.278,0,0,1,5.113,8.253,8.908,8.908,0,0,1,7.208,6.178a11.967,11.967,0,0,1,2.886-1.509,15.937,15.937,0,0,1,3.518-.827A43.256,43.256,0,0,1,18.2,3.562c.8-.016,1.608-.022,2.406-.026l2.979,0H264.914",
    transform: "translate(0.984 0.984)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(42 11.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "eCheck",
    className: "cls-2",
    transform: "translate(90 56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "eCheck")), /*#__PURE__*/React.createElement("g", {
    id: "Group_8639",
    "data-name": "Group 8639",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-3",
    width: 78,
    height: 78
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(3.254 17.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-4",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 71.579,
    height: 42.296,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1,
    y: 1,
    width: 69.579,
    height: 40.296,
    rx: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    className: "cls-5",
    x2: 26,
    transform: "translate(12.746 13.05)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "cls-5",
    x2: 26,
    transform: "translate(12.746 22.05)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    className: "cls-5",
    x2: 20,
    transform: "translate(38.746 31.05)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcheckpayAsset);
export default __webpack_public_path__ + "static/media/echeckpay_asset.98d7327cd9f842c789f8ccee7bd65f15.svg";
export { ForwardRef as ReactComponent };